import { AfterContentChecked, Directive, ElementRef, HostListener, Renderer2, AfterContentInit, AfterViewChecked, AfterViewInit, OnInit } from '@angular/core';

@Directive({
  selector: '[appElementProportionalResize]'
})
export class ElementProportionalResizeDirective implements OnInit, AfterViewChecked, AfterContentChecked {

  startWidth: number;

  startInnerWidth: number;
  innerWidth = window.innerWidth;
  percentInnerWidth: number;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    this.startInnerWidth = this.innerWidth;

  }
  ngAfterContentChecked(): void {
    if (this.startInnerWidth < 1280) {
      this.resolveScaleElement();

    }

  }
  ngAfterViewChecked(): void {
    const startWidth = this.elementRef.nativeElement.offsetWidth;
    this.percentInnerWidth = this.innerWidth / 1280;
    if (this.startWidth === undefined && startWidth !== 0) {
      this.startWidth = startWidth *   this.percentInnerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  onresize(): void {
    this.innerWidth = window.innerWidth;
    this.resolveScaleElement();

  }

  resolveScaleElement() {
    const percentInnerWidth = this.innerWidth / 1280;
    const currentWidth = this.startWidth * percentInnerWidth;
    const percentWidth = currentWidth  / this.startWidth;
    const scaleValues = 1 * percentWidth;
    if (percentInnerWidth < 1) {

      this.renderer.setStyle(this.elementRef.nativeElement, 'transform', `scale3d(${scaleValues}, ${scaleValues}, ${scaleValues})`);
    }
  }
}
